import { render, staticRenderFns } from "./index-contactos.vue?vue&type=template&id=d21990e4"
import script from "./index-contactos.vue?vue&type=script&lang=js"
export * from "./index-contactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports